import React, { useCallback, useState } from "react"

import { Company, BarGraph, Help, Setting } from "../ImageComponents"
import { RiArrowDropDownFill } from "react-icons/ri"
import { logout } from "../../container/LoginContainer"
import clickOutSideHook from "../../core/utils/hooks/listen-click-outside"

import "./styles.scss"
import { colorsAvatar } from "../../core/utils/colorsAvatars"
import { Avatar } from "../Avatar"
import Send from "../../core/communication"
import { useNavigate } from "react-router-dom"

export const NavHome = ({ navigate }) => {
  const { pathname } = location

  const navList = () => [
    { name: "/admin/companies", translate: "Empresas", icon: <Company /> },
    { name: "/admin/questions", translate: "Banco de Questões", icon: <Help /> },
    { name: "/admin/indicators", translate: "Indicadores", icon: <BarGraph /> },
    { name: "/admin/rules", translate: "Regras", icon: <Setting /> },
  ]

  return (
    <nav className="nav-header">
      <ul>
        {navList &&
          navList().map((item, index) => (
            <li
              key={index}
              onClick={() => navigate(item.name)}
              className={`nav-header__item ${pathname == item.name ? "active" : "inactive"}`}>
              <div className="nav-header__item-icon">{item.icon}</div>
              {item.translate}
            </li>
          ))}
      </ul>
    </nav>
  )
}

export const UserMenu = ({ userName, userImage, className, collapsed }) => {
  const navigate = useNavigate()
  const [reload, setReload] = useState(true)
  const { isActive, setIsActive, ref } = clickOutSideHook(false)

  const toggleOnOff = () => {
    const online = !Send.isOnline()
    Send.setOnline(online)

    if (!online) {
      navigate("/offline")
    } else {
      navigate("/")
    }
    setReload((reload) => !reload)
  }

  const menuOptions = useCallback(
    () => [
      { label: Send.isOnline() ? "Usar Offline" : "Usar Online", onClick: () => toggleOnOff() },
      { label: "Sair", onClick: () => logout() },
    ],
    [reload],
  )

  return (
    <div className={`auth-menu${className ? " " + className : ""}`}>
      <div
        className="auth-menu__content"
        ref={ref}
        onClick={() => setIsActive(!isActive)}
        style={collapsed ? { justifyContent: "center" } : {}}>
        <div className="auth-menu-user">
          <Avatar
            icon={userImage}
            backgroundColor={colorsAvatar[2]?.bgColor}
            foregroundColor={colorsAvatar[2]?.color}
          />
          <div className="auth-menu-user-info" onClick={() => logout()}>
            <span className="auth-menu-user-info-name">{userName}</span>
            <span className="auth-menu-user-info-logout">Sair</span>
          </div>
        </div>
        {collapsed && (
          <nav
            className={`auth-menu-dropdown auth-menu-dropdown--${
              isActive ? "active" : "inactive"
            }`}>
            <ul>
              <li key={Math.random()}>{userName}</li>
              {menuOptions(reload).map((item, index) => (
                <li key={index} onClick={() => item.onClick()}>
                  {item.label}
                </li>
              ))}
            </ul>
          </nav>
        )}
      </div>
    </div>
  )
}
